import Swal from 'sweetalert2';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import AudioIcon from '../icons/audio.svg';

import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';

export default class Audio extends Plugin {
    static get requires() {
        return [MediaEmbed];
    }

    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('audio', (locale) => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Coloque a url do audio',
                icon: AudioIcon,
                tooltip: true,
            });

            // Callback executed once the audio is clicked.
            view.on('execute', async () => {
                const { value: url } = await Swal.fire({
                    input: 'text',
                    inputPlaceholder: 'Coloque a URL do audio',
                });

                if (url) {
                    editor.model.change((writer) => {
                        const audioElement = writer.createElement('media', {
                            url: url,
                        });

                        editor.model.insertContent(
                            audioElement,
                            editor.model.document.selection
                        );
                    });
                }
            });

            return view;
        });
    }
}
